/**
 * <symbol-picker>
 * Grid of symbols; single selection; writes one code to a hidden cart property input.
 */
if (!customElements.get('symbol-picker')) {
  customElements.define(
    'symbol-picker',
    class SymbolPicker extends HTMLElement {
      connectedCallback() {
        this.propertyInput = this.querySelector('[data-symbol-property]');
        this.display = this.querySelector('[data-symbol-display]');
        this.selectedEl = this.querySelector('[data-symbol-selected]');
        this.clearBtn = this.querySelector('[data-symbol-clear]');
        this.errorEl = this.querySelector('[data-symbol-error]');
        this.options = Array.from(this.querySelectorAll('[data-symbol-option]'));
        this.errorMessage = this.dataset.errorMessage || 'This field is required.';
        this.selected = null;

        this.options.forEach((btn) => {
          btn.addEventListener('click', () => this.selectOption(btn));
        });

        if (this.clearBtn) {
          this.clearBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.clearSelection();
          });
        }

        this.syncProperty();
        this.renderSelected();
      }

      selectOption(btn) {
        const code = btn.dataset.code;
        if (!code) return;

        this.selected = {
          code,
          image: btn.dataset.image || '',
          label: btn.dataset.label || code
        };

        this.syncOptionStates();
        this.syncProperty();
        this.renderSelected();
        this.clearError();
      }

      syncOptionStates() {
        const activeCode = this.selected?.code || '';
        this.options.forEach((btn) => {
          const on = btn.dataset.code === activeCode;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      syncProperty() {
        if (!this.propertyInput) return;
        this.propertyInput.value = this.selected?.code || '';
      }

      renderSelected() {
        const filled = this.selected != null;
        this.display?.classList.toggle('is-filled', filled);

        if (this.selectedEl) {
          if (!filled) {
            this.selectedEl.innerHTML = '';
          } else {
            const s = this.selected;
            this.selectedEl.innerHTML =
              `<span class="symbol-picker__chip" title="${this.escapeHtml(s.label)}">` +
              (s.image
                ? `<img src="${this.escapeAttr(s.image)}" alt="" width="32" height="32">`
                : `<span class="symbol-picker__symbol-fallback">${this.escapeHtml(s.code)}</span>`) +
              '</span>';
          }
        }

        if (this.clearBtn) this.clearBtn.hidden = !filled;
      }

      clearSelection() {
        this.selected = null;
        this.syncOptionStates();
        this.syncProperty();
        this.renderSelected();
        this.clearError();
      }

      clearError() {
        this.errorEl?.setAttribute('hidden', '');
        if (this.errorEl) this.errorEl.textContent = '';
        this.closest('.input-modal__field')?.classList.remove('input-modal__field--error');
      }

      showError(message) {
        const msg = message || this.errorMessage;
        if (this.errorEl) {
          this.errorEl.textContent = msg;
          this.errorEl.removeAttribute('hidden');
        }
        this.closest('.input-modal__field')?.classList.add('input-modal__field--error');
      }

      validate() {
        this.clearError();
        const field = this.closest('[data-input-modal-field]');
        const required = field?.dataset.inputModalFieldRequired === 'true';
        if (!required) return true;
        if (this.selected != null) return true;
        this.showError(field?.dataset.inputModalFieldError || this.errorMessage);
        return false;
      }

      reset() {
        this.clearSelection();
      }

      escapeHtml(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      escapeAttr(str) {
        return this.escapeHtml(str).replace(/'/g, '&#39;');
      }
    }
  );
}
